import { withStyles, WithStyles } from "@material-ui/core/styles";
import React, { useEffect } from "react";
import { Link } from "@material-ui/core";
import { styles } from "./AuthButton.styles";
import { useAuthContext } from "../../../auth/AuthProvider";

interface IAuthButtonProps extends WithStyles<typeof styles> {
}

const AuthButtonPure: React.FunctionComponent<IAuthButtonProps> = ({classes}: IAuthButtonProps) => {

    const authContext = useAuthContext();

    useEffect(() => {
        authContext.initAuth();
        // eslint-disable-next-line
    }, []);

    if (authContext.isAuthenticated) {
        return (
            <Link color="inherit" onClick={() => authContext.logoutWithRedirect()} className={classes.link}>
                Logout
            </Link>
        );
    } else {
        return (
            <Link color="inherit" onClick={() => authContext.requestAuth()} className={classes.link}>
                Login
            </Link>
        );
    }
};

export const AuthButton = withStyles(styles)(AuthButtonPure);
